export default "https://cdn-static.gokick.com/assets/b944ecdade3ab4b24738bd1fcec1eea00d00fb75/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";